import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";

const SampleApprovalForm = (props) => {
  const modalStyles2 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "600px",
      maxHeight: "500px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});

  const [loading, setLoading] = useState(false);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const observationRef = useRef({});
  const [ObservationDetails, setObservationDetails] = useState([]);
  const [isObservationOpen, setIsObservationOpen] = useState(false);

  const [employeeId, setEmployeeId] = useState();
  const [units, setUnits] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleAttachmentChange = (e) => {
    const files = e.target.files;
      const attachmentFolder=localStorage.getItem("attachmentFolder");

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];
    

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/SampleApproval/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const [lotData, setlotData] = useState([]);

  const { sendRequest: getLot } = useHttp();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "AUP",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        console.log(data);

        setlotData(data);
      }
    );
  }, [getLot]);

  const { sendRequest: getObservation } = useHttp();

  const handleLotIdChange = (e) => {
    // //console.log(e.target.value);
    const id = e.target.value;

    const data = lotData && lotData.filter((item) => item.stockId == id);

    console.log(data);
    frmRef.current.product_name.value = data[0] && data[0].productName;
    frmRef.current.avl_qty.value =
      data[0] &&
      data[0].productQuantityBal + " " + data[0].productunitAbbreviation;
    frmRef.current.crop_name.value = data[0] && data[0].productSubTypeName;
    frmRef.current.variety.value = data[0] && data[0].productTypeName;

    // //console.log("data", data);
    const varietyId = data[0] && data[0].varietyId;
    getObservation(
      {
        url: `/api/varietywiseSeedQualityParamter/?orgId=${localStorage.getItem(
          "orgId"
        )}&varietyId=${varietyId}`,
      },
      (data) => {
        // //console.log(data);
        setObservationDetails(data);
      }
    );
  };

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //  setUnits(res);
          // //console.log(res);

          const filteredUnits =
            res && res.filter((item) => item.unitTypeId == 2);
          // //console.log(filteredUnits);
          setUnits(filteredUnits);
        }
      }
    );
  }, [getunits]);

  const handleObservationChange = (e, index) => {
    const newValue = e.target.value;

    setObservationDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].observation = newValue;
      // //console.log(updatedDetails);
      return updatedDetails;
    });
  };

  const { sendRequest: postApproval } = useHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const data = {
      seedApprovalDate: moment(frmRef.current.approval_date.value).format(
        "DD/MM/YYYY"
      ),
      timeStamp: frmRef.current.inspection_time.value,
      supervisorEmployeeId: frmRef.current.inspected_by.value,
      stockId: frmRef.current.lot_id.value,
      temperature: frmRef.current.temp.value,
      sampleQty: frmRef.current.sample_qty.value,
      unitId: frmRef.current.unit.value,
      seedClass: frmRef.current.seed_class.value,
      paramterDetail: ObservationDetails,
      attachmentUrl: uploadedFiles,
      result: frmRef.current.result.value,
      authorizedAgencyName: frmRef.current.agency_name.value,
      authorizedAgencyAddress: frmRef.current.agency_address.value,
      authorizedAgencyContactNo: frmRef.current.agency_contact_no.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      reamrk: "",
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    // //console.log(data);
    postApproval(
      {
        url: "/api/seedApprovalByAgency/",
        method: "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);
        toast.success(`Sample Approval By Agency done`);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={handleSubmit}>
                <div className="card-header">
                  <h3 className="card-title">Sample Approval Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"approval_date"}>
                        {" "}
                        {"Sample Approval  Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"approval_date"}
                        required
                        ref={(el) => (frmRef.current["approval_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        defaultValue={getCurrentTime()}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspected_by"}>{"Inspected By"}</label>
                      <select
                        id="inspected_by"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspected_by"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              key={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}> {"Lot Id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                        onChange={handleLotIdChange}
                      >
                        <option value="">Select</option>
                        {lotData &&
                          lotData.map((x) => (
                            <option value={x.stockId}>{x.lotNo}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Product Name"}</label>
                      <input
                        type={"text"}
                        id={"product_name"}
                        required
                        ref={(el) => (frmRef.current["product_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"crop_name"}> {"Crop Name"}</label>
                      <input
                        type={"text"}
                        id={"crop_name"}
                        required
                        ref={(el) => (frmRef.current["crop_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Variety"}</label>
                      <input
                        type={"text"}
                        id={"variety"}
                        required
                        ref={(el) => (frmRef.current["variety"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shelf_life"}>{"Temperature(°C)"}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        required
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"avl_qty"}> {"Available Quantity"}</label>
                      <input
                        type={"text"}
                        id={"avl_qty"}
                        min="0"
                        required
                        ref={(el) => (frmRef.current["avl_qty"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sample_qty"}>
                        {" "}
                        {"Total Sample Qty"}
                      </label>
                      <input
                        type={"text"}
                        id={"sample_qty"}
                        required
                        ref={(el) => (frmRef.current["sample_qty"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"unit"}> {"Unit"}</label>
                      <select
                        id="unit"
                        required
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["unit"] = el)}
                      >
                        <option selected disabled value="">
                          Select
                        </option>

                        {units &&
                          units.map((x) => (
                            <option value={x.unitId}>{x.unitName}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"seed_class"}>{"Seed Classes"}</label>
                      <select
                        id="seed_class"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["seed_class"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="Nuclear seed">Nuclear seed</option>
                        <option value="Breeder seed">Breeder seed</option>
                        <option value="Foundation seed">Foundation seed</option>
                        <option value="Registered seed">Registered seed</option>
                        <option value="Certified seed">Certified seed</option>
                        <option value="Labelled Seed">Labelled Seed</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"agency_name"}>
                        {" "}
                        {"Authorized Agency Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"agency_name"}
                        required
                        ref={(el) => (frmRef.current["agency_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"agency_address"}>
                        {" "}
                        {"Authorized Agency Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"agency_address"}
                        required
                        ref={(el) => (frmRef.current["agency_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"agency_contact_no"}>
                        {" "}
                        {"Authorized Agency Contact No"}
                      </label>
                      <input
                        type={"text"}
                        id={"agency_contact_no"}
                        required
                        ref={(el) => (frmRef.current["agency_contact_no"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"observation_paramter"}>
                        {" "}
                        {"Observation Paramter"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"observation_paramter"}
                        autoComplete="off"
                        ref={(el) =>
                          (frmRef.current["observation_paramter"] = el)
                        }
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setIsObservationOpen(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"result"}>{"Result"}</label>
                      <select
                        id="result"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["result"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="pass">Pass</option>
                        <option value="fail">Fail</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Attachment"}>{"Attachment"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"attachment"}
                          ref={(el) => (frmRef.current["attachment"] = el)}
                          className="form-control"
                          multiple
                          onChange={handleAttachmentChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {isObservationOpen && (
        <Modal isOpen={true} style={modalStyles2}>
          <div className="">
            <h3 className="card-title">Observation Paramter</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsObservationOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <form>
            <div>
              <table className="table table-bordered table-sm text-center">
                <thead>
                  <tr className="">
                    <th>Sr No</th>
                    <th>Paramter Name</th>

                    <th>Observation</th>
                  </tr>
                </thead>
                <tbody>
                  {ObservationDetails &&
                    ObservationDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.parameterName}</td>

                          <td>
                            <input
                              type="text"
                              id={`Observation-${i}`}
                              required
                              ref={(el) =>
                                (frmRef.current[`observation-${i}`] = el)
                              }
                              className="form-control"
                              value={itm.observation || ""}
                              onChange={(e) => handleObservationChange(e, i)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <br />
            <div className="text-center">
              <button
                type="submit"
                className="btn-sm btn-success btn"
                onClick={() => setIsObservationOpen(false)}
              >
                Save
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};

export default SampleApprovalForm;
